import { render, staticRenderFns } from "./TabUserNfts.vue?vue&type=template&id=4bbdb0b6&"
import script from "./TabUserNfts.vue?vue&type=script&lang=js&"
export * from "./TabUserNfts.vue?vue&type=script&lang=js&"
import style0 from "./TabUserNfts.vue?vue&type=style&index=0&id=4bbdb0b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports